const stateAbbreviations = {
    // **India**
    "Andhra Pradesh": "AP",
    "Arunachal Pradesh": "AR",
    "Assam": "AS",
    "Bihar": "BR",
    "Chhattisgarh": "CG",
    "Goa": "GA",
    "Gujarat": "GJ",
    "Haryana": "HR",
    "Himachal Pradesh": "HP",
    "Jharkhand": "JH",
    "Karnataka": "KA",
    "Kerala": "KL",
    "Madhya Pradesh": "MP",
    "Maharashtra": "MH",
    "Manipur": "MN",
    "Meghalaya": "ML",
    "Mizoram": "MZ",
    "Nagaland": "NL",
    "Odisha": "OR",
    "Punjab": "PB",
    "Rajasthan": "RJ",
    "Sikkim": "SK",
    "Tamil Nadu": "TN",
    "Telangana": "TG",
    "Tripura": "TR",
    "Uttar Pradesh": "UP",
    "Uttarakhand": "UK",
    "West Bengal": "WB",
    "Delhi": "DL",
    "Jammu and Kashmir": "JK",
    "Ladakh": "LA",
    "Puducherry": "PY",
    "Chandigarh": "CH",
    "Dadra and Nagar Haveli and Daman and Diu": "DN",
    "Andaman and Nicobar Islands": "AN",
    "Lakshadweep": "LD",
  
    // **United States**
    "Alabama": "AL",
    "Alaska": "AK",
    "Arizona": "AZ",
    "Arkansas": "AR",
    "California": "CA",
    "Colorado": "CO",
    "Connecticut": "CT",
    "Delaware": "DE",
    "Florida": "FL",
    "Georgia": "GA",
    "Hawaii": "HI",
    "Idaho": "ID",
    "Illinois": "IL",
    "Indiana": "IN",
    "Iowa": "IA",
    "Kansas": "KS",
    "Kentucky": "KY",
    "Louisiana": "LA",
    "Maine": "ME",
    "Maryland": "MD",
    "Massachusetts": "MA",
    "Michigan": "MI",
    "Minnesota": "MN",
    "Mississippi": "MS",
    "Missouri": "MO",
    "Montana": "MT",
    "Nebraska": "NE",
    "Nevada": "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    "Ohio": "OH",
    "Oklahoma": "OK",
    "Oregon": "OR",
    "Pennsylvania": "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    "Tennessee": "TN",
    "Texas": "TX",
    "Utah": "UT",
    "Vermont": "VT",
    "Virginia": "VA",
    "Washington": "WA",
    "West Virginia": "WV",
    "Wisconsin": "WI",
    "Wyoming": "WY",
  
    // **Canada**
    "Alberta": "AB",
    "British Columbia": "BC",
    "Manitoba": "MB",
    "New Brunswick": "NB",
    "Newfoundland and Labrador": "NL",
    "Nova Scotia": "NS",
    "Ontario": "ON",
    "Prince Edward Island": "PE",
    "Quebec": "QC",
    "Saskatchewan": "SK",
  
    // **Australia**
    "Australian Capital Territory": "ACT",
    "New South Wales": "NSW",
    "Northern Territory": "NT",
    "Queensland": "QLD",
    "South Australia": "SA",
    "Tasmania": "TAS",
    "Victoria": "VIC",
    "Western Australia": "WA",
  
    // **Brazil**
    "Acre": "AC",
    "Alagoas": "AL",
    "Amazonas": "AM",
    "Bahia": "BA",
    "Ceará": "CE",
    "Espírito Santo": "ES",
    "Goiás": "GO",
    "Maranhão": "MA",
    "Mato Grosso": "MT",
    "Mato Grosso do Sul": "MS",
    "Minas Gerais": "MG",
    "Pará": "PA",
    "Paraíba": "PB",
    "Paraná": "PR",
    "Pernambuco": "PE",
    "Piauí": "PI",
    "Rio de Janeiro": "RJ",
    "Rio Grande do Norte": "RN",
    "Rio Grande do Sul": "RS",
    "Rondônia": "RO",
    "Roraima": "RR",
    "Santa Catarina": "SC",
    "São Paulo": "SP",
    "Sergipe": "SE",
    "Tocantins": "TO",
  
    // **Russia**
    "Adygea": "AD",
    "Altai": "AL",
    "Amur": "AM",
    "Arkhangelsk": "AR",
    "Astrakhan": "AS",
    "Bashkortostan": "BA",
    "Belgorod": "BE",
    "Bryansk": "BR",
    "Buryatia": "BU",
    "Chechen Republic": "CR",
    "Chelyabinsk": "CH",
    "Chukchi Autonomous Okrug": "CAO",
    "Chuvashia": "CHU",
    "Dagestan": "DA",
    "Ingushetia": "IN",
    "Irkutsk": "IR",
    "Ivanovo": "IV",
    "Jewish Autonomous Okrug": "JAO",
    "Kaliningrad": "KA",
    "Kaluga": "KL",
    "Kamchatka": "KA",
    "Kemerovo": "KE",
    "Khabarovsk": "KH",
    "Khakassia": "KH",
    "Khanty-Mansi Autonomous Okrug": "KMAO",
    "Kirov": "KI",
    "Komi": "KO",
    "Kostroma": "KO",
    "Krasnodar Krai": "KK",
    "Krasnoyarsk Krai": "KK",
    "Kurgan": "KU",
    "Kursk": "KU",
    "Leningrad": "LE",
    "Lipetsk": "LI",
    "Magadan": "MA",
    "Mari El": "ME",
    "Moscow": "MO",
    "Murmansk": "MU",
    "Nizhny Novgorod": "NN",
    "Novgorod": "NO",
    "Novosibirsk": "NO",
    "Omsk": "OM",
    "Orenburg": "OR",
    "Oryol": "OR",
    "Penza": "PE",
    "Perm": "PE",
    "Primorsky Krai": "PK",
    "Pskov": "PS",
    "Republic of Sakha (Yakutia)": "RS",
    "Samara": "SA",
    "Saratov": "SA",
    "Sakhalin": "SA",
    "Sverdlovsk": "SV",
    "Tambov": "TA",
    "Tatarstan": "TA",
    "Tomsk": "TO",
    "Tula": "TU",
    "Tyumen": "TY",
    "Udmurtia": "UD",
    "Ulyanovsk": "UL",
    "Vladimir": "VL",
    "Volgograd": "VO",
    "Vologda": "VO",
    "Voronezh": "VO",
    "Yamal-Nenets Autonomous Okrug": "YNAO",
    "Yaroslavl": "YA",
  
    // **Japan**
    "Aichi": "AI",
    "Akita": "AK",
    "Amami": "AM",
    "Chiba": "CH",
    "Ehime": "EH",
    "Fukui": "FU",
    "Fukuoka": "FU",
    "Gifu": "GI",
    "Gunma": "GU",
    "Hiroshima": "HI",
    "Hokkaido": "HO",
    "Hyogo": "HY",
    "Ibaraki": "IB",
    "Iwate": "IW",
    "Kagawa": "KA",
    "Kagoshima": "KA",
    "Kanagawa": "KA",
    "Kochi": "KO",
    "Kumamoto": "KU",
    "Kyoto": "KY",
    "Mie": "MI",
    "Miyagi": "MI",
    "Miyazaki": "MI",
    "Nagano": "NA",
    "Nagasaki": "NA",
    "Nara": "NA",
    "Niigata": "NI",
    "Oita": "OI",
    "Okayama": "OK",
    "Okinawa": "OK",
    "Osaka": "OS",
    "Saga": "SA",
    "Saitama": "SA",
    "Shiga": "SH",
    "Shimane": "SH",
    "Shizuoka": "SH",
    "Tochigi": "TO",
    "Tokushima": "TO",
    "Tokyo": "TO",
    "Tottori": "TO",
    "Toyama": "TO",
    "Wakayama": "WA",
    "Yamagata": "YA",
    "Yamaguchi": "YA",
    "Yokohama": "YO",
  };
  
  export const getStateCode = (stateName) => stateAbbreviations[stateName] || stateName;
  



// const stateAbbreviations = {
//     "Andhra Pradesh": "AP",
//     "Arunachal Pradesh": "AR",
//     "Assam": "AS",
//     "Bihar": "BR",
//     "Chhattisgarh": "CG",
//     "Goa": "GA",
//     "Gujarat": "GJ",
//     "Haryana": "HR",
//     "Himachal Pradesh": "HP",
//     "Jharkhand": "JH",
//     "Karnataka": "KA",
//     "Kerala": "KL",
//     "Madhya Pradesh": "MP",
//     "Maharashtra": "MH",
//     "Manipur": "MN",
//     "Meghalaya": "ML",
//     "Mizoram": "MZ",
//     "Nagaland": "NL",
//     "Odisha": "OR",
//     "Punjab": "PB",
//     "Rajasthan": "RJ",
//     "Sikkim": "SK",
//     "Tamil Nadu": "TN",
//     "Telangana": "TG",
//     "Tripura": "TR",
//     "Uttar Pradesh": "UP",
//     "Uttarakhand": "UK",
//     "West Bengal": "WB",
//     "Delhi": "DL",
//     "Jammu and Kashmir": "JK",
//     "Ladakh": "LA",
//     "Puducherry": "PY",
//     "Chandigarh": "CH",
//     "Dadra and Nagar Haveli and Daman and Diu": "DN",
//     "Andaman and Nicobar Islands": "AN",
//     "Lakshadweep": "LD"
//   };
  
//   export const getStateCode = (stateName) => stateAbbreviations[stateName] || stateName;
  